import {Injectable} from '@angular/core';
import {IAdComponentData, IConnectorsEdges, IGraphNode, ITagretsNodes, TGraphType,} from '../models/graph-kn.model-interfaces';
import {Group} from 'konva/lib/Group';
import {Vector2d} from 'konva/lib/types';
import {KonvaEventObject} from 'konva/lib/Node';
import {Layer} from 'konva/lib/Layer';
import {GraphKnDataService} from './graph-kn.data.service';
import {LayOutService} from './graph-kn.layout.service';
import {GraphKnUIElementsService} from './graph-kn.ui.elements.service';
import {GraphKnMoveStepRMService} from './graph-kn.move-steps-roadmap.service';
import {CrmGraphService} from '../../../services/api/crm-graph.service';
import { BUSINESS_PROCESS_LAYER_ID, IKnUIOptions } from '../models/graph-kn.cm-api-models';
import { Rect } from 'konva/lib/shapes/Rect';
import { Line } from 'konva/lib/shapes/Line';
import { Arrow } from 'konva/lib/shapes/Arrow';
import { Circle } from 'konva/lib/shapes/Circle';
import { ARROW_MODEL } from '../models/graph-kn.cm.arrows-model-const';
import { RectModelsMap } from '../styles/graph-node-rect-model';
import { NodesStylingMap } from '../styles/nodes-styles/graph-node--map-styles-root';
import { INodeStyleConfing } from '../models/graph-kn.cm.nodes-model-const';

@Injectable({
    providedIn: 'root'
})
export class GraphKnNodeEventsService {

    constructor(
        private knDataService: GraphKnDataService,
        private layOutService: LayOutService,
        private knUIElementsService: GraphKnUIElementsService,
        private knMoveStepRMService: GraphKnMoveStepRMService,
        private crmGraphService: CrmGraphService
        // private knContextMenuService:GraphKnContextMenuService,
    ) {
    }

    createDragEvents(nodeGroup: Group, graphLayer: Layer, connectorsEdges: IConnectorsEdges[], targetsNodes: ITagretsNodes[], graphType: TGraphType, changeStepAllowed = true) {
        nodeGroup.on('dragstart', e => this.dragGroupStart(e, graphLayer, nodeGroup,connectorsEdges));
        nodeGroup.on('dragmove', (e: KonvaEventObject<MouseEvent | TouchEvent, Group>) => {
            let movement = this.dragGroup(e);
            let stepsSwapped = false
            if (graphType === 'contractLayer' && changeStepAllowed && nodeGroup.attrs.data?.subContract !== true) {
                stepsSwapped = this.knMoveStepRMService.dragMoveContract(connectorsEdges, nodeGroup, targetsNodes, graphType, graphLayer)
            }
            stepsSwapped ? null : this.layOutService.updateGraph(connectorsEdges, graphLayer, movement, e.target?.attrs?.id,nodeGroup, graphType);
        });
        if (graphType === 'contractLayer' && nodeGroup.attrs.data?.subContract !== true) {
            nodeGroup.on('dragend', () => this.knMoveStepRMService.dragEndContract(nodeGroup, graphLayer, targetsNodes, connectorsEdges, graphType))
        }
    }

    createHoverEvents(nodeGroup: Group, hoverGroup: Group, graphType: TGraphType) {
        nodeGroup.on('mouseover', () => {
            nodeGroup.opacity(1);
            nodeGroup.moveToTop();
            let addNewStepGroup = (hoverGroup.children.filter(hg => hg.attrs.id.includes('GRAPH.BUTTONS.TOOLTIPS.NODE_ADD'))[0] as unknown as Group);
            addNewStepGroup ?
                graphType === 'contractLayer' && this.knDataService.lastContractStepId !== nodeGroup.attrs.id ? addNewStepGroup.hide() : addNewStepGroup.show()
                : null;
            hoverGroup ? hoverGroup.show() : null;
        })
        nodeGroup.on('mouseout', () => {
           // nodeGroup.opacity(RECT_MODEL.opacity);
            let nodesCountInLayer = (nodeGroup.parent?.children?.filter(el => el instanceof Group)?.length || 1) - 1
            nodesCountInLayer ? nodeGroup.moveDown() : null;
            hoverGroup ? hoverGroup.hide() : null;
        })
    }

    createMobileEvents(nodeGroup: Group, graphType: TGraphType, isContractOpen: boolean,connectorsEdges:IConnectorsEdges[]) {
        nodeGroup.on('tap', e => {
            if (Date.now() - this.knDataService.longTapData.start < this.knDataService.longTapData.duration) {
                this.nodeClickEventHandler(e, nodeGroup, graphType, isContractOpen,connectorsEdges)
            } else {
                e.cancelBubble = false;
                // this.knContextMenuService.openContextMenu(e,stage)
            }
        });
        nodeGroup.on('touchstart', () => this.knDataService.longTapData.start = Date.now());
    }

    nodeClickEventHandler(
        event: KonvaEventObject<MouseEvent, Group>, nodeGroup: Group, 
        graphType: TGraphType, isContractOpen: boolean,connectorsEdges:IConnectorsEdges[]
    ) {
        if (event.evt.button === 0 || (window.TouchEvent && event.evt instanceof TouchEvent)) {
            let previousSelectedGroup = this.knDataService.selectedNodeGroup
            this.knDataService.selectedNodeGroupId = nodeGroup.attrs.id
            this.knDataService.selectedNodeGroup = nodeGroup;
            switch (graphType) {
                case 'bpLayer':
                    this.bpNodeClick(nodeGroup, graphType, connectorsEdges, previousSelectedGroup)
                break;
                case 'contractLayer':
                    let graphNode = nodeGroup.attrs.data as IGraphNode
                    if (graphNode?.contract_step_data?.target_key && graphNode?.contract_step_data?.target_type === 'task') {
                        this.contractTaskClick(graphNode?.contract_step_data?.target_key)
                    } else {
                        this.contractNodeClick(graphNode, isContractOpen)
                    }
                break;
            }
        }
    }

    contractNodeClick(graphNode: IGraphNode, isContractOpen: boolean) {
        this.knDataService.emitNodeEvent.emit({
            action: 'EDIT_NODE',
            data: graphNode,
            canEdit: isContractOpen,
            pureAction: false
        })
    }

    contractTaskClick(target_key: string) {
        this.knDataService.subGraphIsLoading.next(true)
        this.crmGraphService.getGraphTaskStat(target_key).subscribe(taskData => {
            // let nodesToChangeStatus = taskData.available_task_statuses.map(data => data.id.toString())
            taskData.status_nodes.filter(nd => nd.attachments.length).forEach(node => {
                node.data.attachments_files = node.attachments.filter(at => at.attachment_type === 'file' && at.attachment)
                node.data.attachments_images = structuredClone(node.attachments.filter(at => at.attachment_type === 'photo' && at.attachment))
                node.data.task_alias = target_key
            })
            let graphNodesTasks:IGraphNode[] = taskData.status_nodes.map(sn=>{
                return {
                    id:sn.id.toString(),
                    label: sn.label,
                    nodeType:'TaskStep',
                    dimension:{width:0,height:0},
                    position:{x:0,y:0},
                    task_data: {
                        ...sn,
                        task_alias:target_key
                    } 
                }
            })
            taskData.status_nodes
            let transformedTaskData = {
                activeStepId: taskData.current_status.id.toString(),
                nodes: graphNodesTasks,
                edges: taskData.status_edges .map(edge =>{
                    return {
                        id:edge.id.toString(),
                        target:edge.target.toString(),
                        source:edge.source.toString(),
                        points_labels:[]
                    }
                })
            }
            this.knDataService.generateTaskGraphData$.next(transformedTaskData)
            this.knDataService.subGraphIsLoading.next(false)
        })
    }

    bpNodeClick(
        nodeGroup: Group, graphType: TGraphType, connectorsEdges:IConnectorsEdges[], previousSelectedGroup?:Group) {
		if (previousSelectedGroup?.attrs)  {
			this.toggleActiveNodeMode(previousSelectedGroup,connectorsEdges)
		}
		this.toggleActiveNodeMode(nodeGroup, connectorsEdges, this.knDataService.graphUISetting.get(graphType))
    }
    toggleActiveNodeMode(nodeGroup: Group, connectorsEdges:IConnectorsEdges[], activateOptions?: IKnUIOptions) {
        this.knDataService.subUserListOpen.next({top:1,left:1,visibility:'hidden'})
        this.knDataService.subAttachementsListOpen.next({top:1,left:1,visibility:'hidden'})
        let graphNode = nodeGroup.attrs.data as IGraphNode
        let groupID = nodeGroup.attrs.id
        let rectModel = RectModelsMap.get(graphNode?.nodeType)
        let cssNodeActive = (NodesStylingMap.get(graphNode?.nodeType) as INodeStyleConfing)
        if (!cssNodeActive.activeStep) {
            return
        }
        nodeGroup.attrs.active = !nodeGroup.attrs.active
        let stageRect = this.knDataService.graphStage.container().getBoundingClientRect()
        
        let navPanelData:IAdComponentData = {
            left:nodeGroup.getAbsolutePosition().x + stageRect.left + (nodeGroup.attrs?.dimensions?.width||0)/2,
            top:nodeGroup.getAbsolutePosition().y + stageRect.top - 40,
            visibility: nodeGroup.attrs.active? 'visible' : 'hidden',
            width:(nodeGroup.attrs?.dimensions?.width||250)/2,
            data:graphNode,
            rights:activateOptions,
        }
        this.knDataService.subToolBarOpen.next(navPanelData)
  
        let groupRect = nodeGroup.children.find(el=>el.attrs.id==='GroupRect') as Rect
        let groupLine = nodeGroup.children.find(el=>el.attrs.id==='GroupLine') as Line
        
        let groupGraphNode = nodeGroup.attrs.data as unknown as IGraphNode
        let strokeColor = 
            groupGraphNode?.bp_status_data?.data?.colorCode
            ||groupGraphNode?.task_data?.data?.colorCode
            ||cssNodeActive.activeStep.borderColor
        if (nodeGroup.attrs.active && groupRect) {
            groupRect.strokeWidth(cssNodeActive.activeStep.borderWidth)
            groupRect.stroke(strokeColor)
            groupLine?.hide()
        } else {
            rectModel?.strokeWidth? groupRect.strokeWidth(rectModel.strokeWidth) : null
            rectModel?.stroke? groupRect.stroke(rectModel?.stroke) : null
            groupLine?.show()
        }
        cssNodeActive? this.toggleConnectedEdges(connectorsEdges,groupID,nodeGroup.attrs.active,cssNodeActive, strokeColor) : null
    }
    toggleConnectedEdges(connectorsEdges:IConnectorsEdges[],groupID:string,active:boolean,cssNodeActive:INodeStyleConfing,selectColor?:string){
        let cssData = cssNodeActive.activeStep
        if (active === false) {
            selectColor = undefined
            cssData = {
                borderColor:ARROW_MODEL.fill as string,
                edgeWidth:ARROW_MODEL.strokeWidth!,
                borderWidth:ARROW_MODEL.strokeWidth!
            }
        }
        let layer = this.knDataService.layersMap.get(BUSINESS_PROCESS_LAYER_ID)
        let edgesConnectedtoGroup = connectorsEdges.filter(el=>[el.to,el.from].includes(groupID)).map(el=>el.id)
        edgesConnectedtoGroup.forEach(edgeID=>{
            let edge = layer?.layer.findOne('#' + edgeID  + '_edge_path') as Line
            let edgePointer = layer?.layer.findOne('#' + edgeID  + '_edge_pointer') as Circle|Rect|Arrow
            let deleteEdgeButton = layer?.layer.findOne('#' + edgeID  + 'DeleteButton') as Group
            let deleteEdgeButtonPos:Vector2d = this.knUIElementsService.calcDeleteButtonPostion(edge.points(),cssNodeActive)
            edge?.strokeWidth(cssData.edgeWidth)
            edge?.stroke(selectColor||cssData.borderColor)
            edgePointer?.strokeWidth(cssData.edgeWidth)
            edgePointer?.stroke(selectColor||cssData.borderColor)
            edgePointer?.fill(selectColor||cssData.borderColor)
            deleteEdgeButton?.position(deleteEdgeButtonPos)
            active? deleteEdgeButton?.show() : deleteEdgeButton?.hide();
            active? deleteEdgeButton?.moveToTop() : null;
        })
    }
    dragGroupStart(e: KonvaEventObject<MouseEvent | TouchEvent, Group>, layer: Layer, dragGroup: Group,connectorsEdges?:IConnectorsEdges[]) {
        let nodeData = dragGroup.attrs.data as IGraphNode
        
        nodeData.nodeType === 'contractStep'? this.knMoveStepRMService.dragStartContract(dragGroup, layer) : null;
        let navPanelData:IAdComponentData = {
          left:1,
          top:1,
          visibility:'hidden'
        }
        this.knDataService.subToolBarOpen.next(navPanelData)
        this.knDataService.subUserListOpen.next({top:1,left:1,visibility:'hidden'})
		let previousSelectedGroup = this.knDataService.selectedNodeGroup
		if (previousSelectedGroup?.attrs && connectorsEdges)  {
			this.toggleActiveNodeMode(previousSelectedGroup, connectorsEdges, undefined)
			this.knDataService.selectedNodeGroup = undefined
			this.knDataService.selectedNodeGroupId = ''
		}
        if (window.TouchEvent && e.evt instanceof TouchEvent) {
            this.knDataService.lastTouchPostion = {
                x: e.evt?.targetTouches[0]?.pageX,
                y: e.evt?.targetTouches[0]?.pageY
            }
        }
    }
    dragGroup(e: KonvaEventObject<MouseEvent | TouchEvent, Group>): Vector2d {
        let movement: Vector2d = {x: 0, y: 0}
        e.cancelBubble = true
        if (window.TouchEvent && e.evt instanceof TouchEvent) {
            movement = {
                x: e.evt?.targetTouches[0]?.pageX - this.knDataService.lastTouchPostion.x,
                y: e.evt?.targetTouches[0]?.pageY - this.knDataService.lastTouchPostion.y
            }
            this.knDataService.lastTouchPostion = {
                x: e.evt?.targetTouches[0]?.pageX,
                y: e.evt?.targetTouches[0]?.pageY
            }
        } else {
            movement = {
                x: (e.evt as MouseEvent).movementX,
                y: (e.evt as MouseEvent).movementY
            }
        }
        return movement
    }
}